import baseStyles from './base'

export default {
  base: baseStyles,
}
